export default {
  methods: {
    maskField (val, mask) {
      let str = val.split('')
      let countValue = 0
      let countMask = 0
      for (let i = 0; i < mask.length; i++) {
        if (val.charAt(countValue)) {
          if (mask.charAt(i) === '#') {
            countValue++
            mask = mask.substr(0, i) + str.shift() + mask.substr(i + 1)
          } else {
            countMask++
          }
        } else {
          return mask.substr(0, countMask + countValue)
        }
      }
      return mask
    },
    maskMoney (val, type = 1, fixed = 2) {
      return type === 1 ? 'R$ ' + (parseFloat(val)).toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '$ ' + (parseFloat(val)).toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mask.js